<form class="td-wb-form"
      (ngSubmit)="maybeSubmitForm()">
  <div class="td-wb-vh"
       role="region"
       [attr.aria-labelledby]="accessibleHeaderId"
       [attr.aria-hidden]="!hasErrors()">
    @if (hasErrors()) {
      <h2 [id]="accessibleHeaderId"
          [innerText]="'tdWb.formAccessibility.ERRORS_ARIA' | tdWbTranslate">
      </h2>
    }
    <td-wb-form-accessibility-alert [attr.aria-hidden]="!hasErrors()" />
  </div>
  <ng-content />
</form>
